import { FOTO_DANIELA } from "@/lib/api";

export default function SobreMi() {
  return (
    <div data-testid="sobre-mi-page" className="mx-auto max-w-7xl px-6 py-24">
      <p className="label-xs">Sobre mí</p>
      <h1 className="mt-4 max-w-3xl text-5xl tracking-tight sm:text-6xl">Lic. Daniela Roppel</h1>
      <div className="mt-14 grid gap-16 lg:grid-cols-[0.8fr_1.2fr]">
        <img src={FOTO_DANIELA} alt="Lic. Daniela Roppel" className="w-full object-cover" />
        <div className="space-y-6 leading-relaxed text-[#4a4744]">
          <p className="serif text-2xl text-[#2a2826]">Licenciada en Psicopedagogía. Necochea, Provincia de Buenos Aires.</p>
          <p>
            Mi trabajo se orienta a comprender cómo aprende cada persona: qué la entusiasma, qué la detiene y
            qué recursos necesita para volver a confiar en sus propias posibilidades. Sostengo una práctica clínica
            que integra los aportes de las neurociencias, la pedagogía y la escucha singular de cada historia.
          </p>
          <p>
            En Nilo Espacio Psicopedagógico acompaño procesos de evaluación e intervención con niños, adolescentes
            y adultos, articulando el trabajo con las familias, las instituciones educativas y los equipos de salud
            que intervienen en cada caso.
          </p>
          <p>
            Desarrollo además intervenciones en el ámbito de la psicopedagogía forense, elaborando informes técnicos
            en contextos judiciales, con encuadre ético y rigor profesional.
          </p>
          <div className="grid gap-6 border-t border-[#dcd5ce] pt-8 sm:grid-cols-3">
            {[["Clínica psicopedagógica", "Área"], ["Forense", "Especialización"], ["Interdisciplina", "Enfoque"]].map(([a, b]) => (
              <div key={b}>
                <p className="serif text-xl">{a}</p>
                <p className="label-xs mt-1">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
